"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cisTranslations = void 0;
var _types = require("../../../types");
const cisTranslations = exports.cisTranslations = {
  [_types.ErrorPageTranslationKey.headline]: 'Нам очень жаль!',
  [_types.ErrorPageTranslationKey.buttonText]: 'Назад',
  [_types.ErrorPageTranslationKey.text]: 'Эта страница в настоящий момент недоступна',
  [_types.ErrorPageTranslationKey.notFound]: 'К сожалению, введенный вами адрес недоступен',
  [_types.ErrorPageTranslationKey.unauthorized]: 'Страница, на которую вы пытаетесь попасть, ограничена и не выполняет все критерии.',
  [_types.ErrorPageTranslationKey.contactSupportTeam]: 'Пожалуйста, свяжитесь со службой поддержки Oriflame по электронной почте:',
  [_types.ErrorPageTranslationKey.rejectedUrl]: 'Запрошенный URL-адрес отклонен!'
};
